import { render } from "./BoneCrafts.vue?vue&type=template&id=0330bf66"
import script from "./BoneCrafts.vue?vue&type=script&lang=js"
export * from "./BoneCrafts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__